export default "<h1>Verein</h1>\n<h2>Erfolge</h2>";